var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#515ede",
    d: "M122.496 288l194.272-194.272-45.248-45.248-271.52 271.52 271.52 271.52 45.248-45.248-194.272-194.272h517.504v-64h-517.504z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlueArrow);
export default __webpack_public_path__ + "static/media/left-blue-arrow.bf9bf4cf476176f7c3c4834d086a79e6.svg";
export { ForwardRef as ReactComponent };